import React from 'react'
import { ConfigProvider } from 'antd'
import useButtonStyle from './buttonStyle'
import useCardStyle from './cardStyle'
import useInputStyle from './inputStyle'
import useSwitchStyle from './switchStyle'
import useCheckboxStyle from './checkboxStyle'
import useRadioStyle from './radioStyle'
import useTagStyle from './tagStyle'
import useTableStyle from './tableStyle'
import useDividerStyle from './dividerStyle'
import useModalStyle from './modalStyle'
import useSelectStyle from './selectStyle'
import useSpinStyle from './spinStyle'
import useMenuStyle from './menuStyle'
import useDatePickerStyle from './datePickerStyle'
import { PREFIX } from './constant'

interface BlueThemeProviderProps {
  disabled?: boolean
  children?: React.ReactNode
}

export default function BlueThemeProvider({ children, disabled }: BlueThemeProviderProps) {
  const { getPrefixCls } = React.useContext(ConfigProvider.ConfigContext)

  useButtonStyle(getPrefixCls('btn'))
  useCardStyle(getPrefixCls('card'))
  useInputStyle(getPrefixCls('input'))
  useSwitchStyle(getPrefixCls('switch'))
  useCheckboxStyle(getPrefixCls('checkbox'))
  useRadioStyle(getPrefixCls('radio'))
  useTagStyle(getPrefixCls('tag'))
  useTableStyle(getPrefixCls('table'))
  useDividerStyle(getPrefixCls('divider'))
  useModalStyle(getPrefixCls('modal'))
  useSelectStyle(getPrefixCls('select'))
  useDatePickerStyle(getPrefixCls('picker'))
  useSpinStyle(getPrefixCls('spin'))
  useMenuStyle(getPrefixCls('menu'))

  const passedCls = disabled ? undefined : PREFIX

  return (
    <ConfigProvider
      button={{ className: passedCls }}
      card={{ className: passedCls }}
      input={{ className: passedCls }}
      switch={{ className: passedCls }}
      checkbox={{ className: passedCls }}
      radio={{ className: passedCls }}
      tag={{ className: passedCls }}
      table={{ className: passedCls }}
      divider={{ className: passedCls }}
      modal={{ className: passedCls }}
      select={{ className: passedCls }}
      datePicker={{ className: passedCls }}
      spin={{ className: passedCls }}
      menu={{ className: passedCls }}
    >
      {children}
    </ConfigProvider>
  )
}
